import { initializeApp } from 'firebase/app';
import { 
  getAuth, 
  GoogleAuthProvider, 
  signInWithPopup,
  browserLocalPersistence,
  setPersistence
} from 'firebase/auth';
import { getFirestore, setDoc, doc, getDoc, updateDoc } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyCYL7Zo5IswUQBKhKsMZC67_sgRUTIg11Q",
    authDomain: "aislide-57afd.firebaseapp.com",
    projectId: "aislide-57afd",
    storageBucket: "aislide-57afd.firebasestorage.app",
    messagingSenderId: "122918041135",
    appId: "1:122918041135:web:96667ff8722a022bc078da",
    measurementId: "G-FD1K9YW4NJ"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth();

// Initialize auth with persistence immediately
await setPersistence(auth, browserLocalPersistence);

// Then export the configured auth
export { auth };

export const db = getFirestore(app);

const provider = new GoogleAuthProvider();
export const signInWithGoogle = async () => {
    const result = await signInWithPopup(auth, provider);
    
    // Only save to Firestore if this is a new user
    if (result.user) {
        const userDoc = await getDoc(doc(db, 'users', result.user.uid));
        
        if (!userDoc.exists()) {
            // New user - save to Firestore
            await setDoc(doc(db, 'users', result.user.uid), {
                email: result.user.email,
                username: result.user.displayName,
                subscription: false,
                trial: 6,
                createdAt: new Date().toISOString(),
            }, { merge: true });
        }
    }
    return result;
};

export const fetchUserData = async () => {
    const user = auth.currentUser;
    if (!user) return null;
    if (user) {
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists()) {
            return userDoc.data();
        }
    }
    return null;
};

export const updateUserTrial = async ( newTrial) => {
    const user = auth.currentUser;
    if (!user) return null;
    const userRef = await doc(db, 'users', user.uid);
    await updateDoc(userRef, { trial: newTrial });
};

export const onAuthStateChanged = (auth, callback) => {
    return auth.onAuthStateChanged(callback);
};

export default app;